export default "__VITE_ASSET__DvvIn6Ec__"